import { LinearProgress, styled } from '@mui/material'
import { memo } from 'react'

import { colorTokens } from '../../foundations/index.ts'

import { defaultProgressBarHeight, useTransitionHelper } from './progress-bar.util.ts'

type ProgressBarProps = {
  progress: number | undefined
  initialProgress: number
  progressBarHeight?: number | undefined
  className?: string | undefined
}

export const ProgressBar = memo<ProgressBarProps>(function ProgressBar({
  initialProgress,
  progress = 0,
  progressBarHeight = defaultProgressBarHeight,
  className,
}) {
  const progressBarValue = initialProgress + (100 - initialProgress) * progress
  const animatedValue = useTransitionHelper(transitionId, progressBarValue)
  const finalValue = progressBarValue === 0 ? 0 : animatedValue

  return (
    <StyledProgressBar
      color="primary"
      variant="determinate"
      height={progressBarHeight}
      value={finalValue}
      {...(className ? { className } : {})}
    />
  )
})

const transitionId = Symbol('ProgressBar')

const StyledProgressBar = styled(LinearProgress)<{ height: number }>`
  height: ${({ height }) => height}px;

  &.MuiLinearProgress-root {
    background-color: rgb(from ${colorTokens['color-bg-base-active']} r g b / 20%);
  }

  .MuiLinearProgress-bar {
    background-color: ${colorTokens['color-bg-base-active']};
  }
`
